import { Attribute, ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoadingComponent {
  @Input() showBg = false

  constructor(@Attribute('isFullScreen') public isFullScreen = true) {}
}
